/**
 * @description Pack SO company header override (LYN-357)
 *
 * Key features:
 * - Pack session can send a UUID or send nothing (All)
 * - LynxPay keeps reading localStorage when override is unset
 *
 * @dependencies none
 *
 * @notes All is represented as null override — never the string "all"
 */

let override = undefined;

/**
 * @param {string|null} idOrNull UUID or null for All
 */
export function setCompanyHeaderOverride(idOrNull) {
  override = idOrNull;
}

export function clearCompanyHeaderOverride() {
  override = undefined;
}

/**
 * @returns {string|null|undefined} undefined = use localStorage (LynxPay)
 */
export function getCompanyHeaderId() {
  if (override !== undefined) {
    return override;
  }
  if (typeof localStorage === 'undefined') {
    return null;
  }
  return localStorage.getItem('activeCompanyId');
}
